import { postMessageToServiceWorker } from '@hkm/features/app/features/manifest/bus/postMessageToServiceWorker';
import { ServiceWorkerMessageType } from '@hkm/features/app/features/manifest/bus/types';

interface VersionResponse {
  version: string;
}

export async function getServiceWorkerVersion(): Promise<string | undefined> {
  const response = await postMessageToServiceWorker<VersionResponse>({
    type: ServiceWorkerMessageType.Version,
  });

  return response?.version;
}
